import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { DataConfig } from '../../model/types';
import { useDataFetchers } from '../../model/useDataFetchers';

type ContextState = ReturnType<typeof useDataFetchers>;

const Context = createContext<ContextState | null>(null);

interface Props {
  children: ReactNode;
  preset: unknown;
}

export function DataFetchersProvider({ children, preset }: Props) {
  const fetchers = useDataFetchers(preset as DataConfig);

  return <Context.Provider value={fetchers}>{children}</Context.Provider>;
}

export const useDataFetchersContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      'useDataFetchersContext must be used within a DataFetchersProvider',
    );
  }
  return context;
};
